<!-- loading panel with virtual scroll -->
<ng-container *ngIf="panel.useVirtualScroll">
  <!-- loading state -->
  <div
    *ngIf="
      loading &&
      ((activePanel === panel.key && refreshCurrentPanel) ||
        activePanel !== panel.key)
    "
  >
    <va-custom-skeleton
      [customSkeletonConfig]="customSkeletonConfig"
    >
    </va-custom-skeleton>
  </div>
  <!--  populating panel data -->
  <div class="checkbox-wrapper">
    <cdk-virtual-scroll-viewport
      *ngIf="
        !loading ||
        (activePanel == panel.key && !refreshCurrentPanel)
      "
      itemSize="19"
      class="virtual-scroll"
    >
      <nz-list [nzSplit]="false">
        <nz-list-item
          [nzNoFlex]="false"
          *cdkVirtualFor="let item of facetData[panel.key]"
        >
          <label
            nz-checkbox
            [ngModel]="cachedSelections[panel.key][item.value]"
            (ngModelChange)="onOptionChange(panel.key, item)"
            [nzDisabled]="panel['showCount'] && item['count'] == 0"
            title="{{
              panel.key === 'ticker'
                ? item['fullname']
                : item['isAlias']
                  ? item['label'] + 'alias: ' + item['alias']
                  : item['label']
            }}"
            class="option base-level-option"
          >
            <span>{{ item["label"] }}</span>
            <span *ngIf="panel['showCount']" class="count">
              ({{ item["count"] }})
            </span>
            <span *ngIf="item['isAlias']" style="padding-left: 8px"
              >alias: {{ item["alias"] }}</span
            >
          </label>
        </nz-list-item>
      </nz-list>
    </cdk-virtual-scroll-viewport>
  </div>
</ng-container>

<!-- loading panel without virtual scroll -->
<ng-container *ngIf="!panel.useVirtualScroll">
  <!-- loading state -->
  <div
    *ngIf="
      loading &&
      ((activePanel === panel.key && refreshCurrentPanel) ||
        activePanel !== panel.key)
    "
  >
    <va-custom-skeleton
      [customSkeletonConfig]="customSkeletonConfig"
    >
    </va-custom-skeleton>
  </div>
  <!-- populating panel data -->
  <div
    *ngIf="
      !loading || (activePanel == panel.key && !refreshCurrentPanel)
    "
    class="real-scroll-panel-is-not-tree checkbox-wrapper"
  >
    <ng-container *ngFor="let item of facetData[panel.key]">
      <label
        nz-checkbox
        [ngModel]="cachedSelections[panel.key][item.value]"
        (ngModelChange)="onOptionChange(panel.key, item)"
        [nzDisabled]="panel['showCount'] && item['count'] == 0"
        title="{{
          panel.key === 'ticker' ? item['fullname'] : item['label']
        }}"
      >
        <span class="option">{{ item["label"] }}</span>
        <span *ngIf="panel['showCount']" class="count"
          >({{ item["count"] }})</span
        >
      </label>
    </ng-container>
    <ng-container *ngIf="panel.key === 'phase'">
      <nz-divider style="margin: 0px !important"></nz-divider>
      <div class="include-terminated">
        <label style="padding-right: 6px">Include Terminated</label>
        <nz-switch
          nzSize="small"
          [(ngModel)]="facetFilter['include_terminated']"
          (ngModelChange)="onSwitchChange($event)"
        ></nz-switch>
      </div>
    </ng-container>
    <ng-container *ngIf="panel.key === 'geo'">
      <!-- <nz-divider style="margin: 0px !important"></nz-divider> -->
      <div class="geo-info">
        <span class="geo-info-label">About Regions</span>
        <span class="geo-info-icon">
          <i
            nz-popover
            nzPopoverPlacement="right"
            nzPopoverContent="In some cases, similar regions are used as a proxy for the displayed geographies (i.e. North America used in place of US)."
            nzPopoverTrigger="hover"
            class="info-icon"
            [nzPopoverOverlayStyle]="{ width: '261px' }"
          >
            <va-icon size="small" name="info-circle"></va-icon>
          </i>
        </span>
      </div>
    </ng-container>
  </div>
</ng-container>